import React from "react";
import post_1 from "../../assets/images/blog-post-1.jpg";
import post_2 from "../../assets/images/blog-post-2.jpg";
import post_3 from "../../assets/images/blog-post-3.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Pagination } from "swiper/modules";
const HomePageBlog = () => {
  const dataBlogs = [
    {
      image: post_1,
      title: "Dental or Implant. What is the Best?",
      description: "The decision between dental implants and…",
      date: " Jan 05, 2024",
    },
    {
      image: post_2,
      title: "Dental or Implant. What is the Best?",
      description: "The decision between dental implants and…",
      date: " Jan 05, 2024",
    },
    {
      image: post_3,
      title: "Dental or Implant. What is the Best?",
      description: "The decision between dental implants and…",
      date: " Jan 05, 2024",
    },
    {
      image: post_1,
      title: "Dental or Implant. What is the Best?",
      description: "The decision between dental implants and…",
      date: " Jan 05, 2024",
    },
    {
      image: post_2,
      title: "Dental or Implant. What is the Best?",
      description: "The decision between dental implants and…",
      date: " Jan 05, 2024",
    },
    {
      image: post_3,
      title: "Dental or Implant. What is the Best?",
      description: "The decision between dental implants and…",
      date: " Jan 05, 2024",
    },
    {
      image: post_1,
      title: "Dental or Implant. What is the Best?",
      description: "The decision between dental implants and…",
      date: " Jan 05, 2024",
    },
    {
      image: post_2,
      title: "Dental or Implant. What is the Best?",
      description: "The decision between dental implants and…",
      date: " Jan 05, 2024",
    },
    {
      image: post_3,
      title: "Dental or Implant. What is the Best?",
      description: "The decision between dental implants and…",
      date: " Jan 05, 2024",
    },
  ];
  return (
    <div className="flex justify-center items-center  flex-col py-28">
      <div className=" text-[#243FFA] text-[16px] text-center font-normal font-outfit">
        ARTICLES & TIPS
      </div>
      <h2 className="xl:text-[52px] text-[32px] font-outfit text-center font-semibold text-[#0F2349]">
        Latest News & Blogs
      </h2>
      <div className="w-full max-w-screen-xl h-full ">
        <Swiper
          modules={[Pagination]}
          spaceBetween={10}
          loop={true}
          grabCursor={true}
          centeredSlides={false} // important when showing 4 cards
          pagination={{ clickable: true, el: ".custom-swiper-paginations" }}
          breakpoints={{
            320: { slidesPerView: 1 },
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="w-full"
        >
          {dataBlogs.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="flex flex-col w-full h-[540px] xl:px-2 px-4  mt-10 items-center pt-10 pb-6 relative rounded-xl   group">
                <figure className="w-full h-[342px] group mb-6  rounded-xl overflow-hidden shadow-md group-hover:translate-y-4 transition-all group-hover:duration-500">
                  <img
                    src={item.image}
                    alt={index+145454654}
                    className="w-full h-full object-cover transition-all duration-300 group-hover:brightness-90 group-hover:contrast-110"
                  />
                </figure>
                <div className="top-1/2 w-4/5 absolute h-auto z-50 py-6 px-6 rounded-xl border-b-2 border-[#243FFA] bg-white group-hover:-translate-y-4  transition-all group-hover:duration-500">
                  <p className="flex flex-row gap-2 text-[#243FFA] font-outfit font-normal mb-2 justify-start items-center">
                    {" "}
                    <span>
                      {" "}
                      <CalendarMonthIcon />{" "}
                    </span>
                    <span>{item.date}</span>
                  </p>
                  <h5 className="font-outfit text-xl mb-2 font-semibold">
                    {item.title}
                  </h5>
                  <p className="text-lg text-[#757887] font-outfit font-normal">
                    {item.description}
                  </p>
                  <p className="text-[16px] mt-4 font-bold font-outfit">
                    <a href="/" className="text-[#243ffa]">
                      Learn More <NavigateNextIcon />
                    </a>
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="custom-swiper-paginations z-50 mt-12  flex justify-center"></div>
      </div>
    </div>
  );
};

export default HomePageBlog;
